
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.75 2.25h3a.75.75 0 01.75.75v12a.75.75 0 01-.75.75H1.25A.75.75 0 01.5 15V3a.75.75 0 01.75-.75h3V.75h1.5v1.5h4.5V.75h1.5v1.5zM2 6.75v7.5h12v-7.5H2zm1.5 1.5H5v1.5H3.5v-1.5zm3.75 0h1.5v1.5h-1.5v-1.5zm3.75 0h1.5v1.5H11v-1.5z","fill":"#7D1E36"}})])
          )
        }
      }
    